/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Google_Loading_LabelInputs */

const en_login_page_google_loading_label = /** @type {(inputs: Login_Page_Google_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in with Google…`)
};

const de_login_page_google_loading_label = /** @type {(inputs: Login_Page_Google_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung mit Google…`)
};

const pt_br2_login_page_google_loading_label = /** @type {(inputs: Login_Page_Google_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrando com o Google…`)
};

const tr_login_page_google_loading_label = /** @type {(inputs: Login_Page_Google_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google ile giriş yapılıyor…`)
};

const zh_cn2_login_page_google_loading_label = /** @type {(inputs: Login_Page_Google_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在使用 Google 登录…`)
};

const zh_hk2_login_page_google_loading_label = /** @type {(inputs: Login_Page_Google_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在使用 Google 登入…`)
};

const ko_kr2_login_page_google_loading_label = /** @type {(inputs: Login_Page_Google_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google로 로그인하는 중…`)
};

const ru_ru2_login_page_google_loading_label = /** @type {(inputs: Login_Page_Google_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вход через Google…`)
};

const es_419_login_page_google_loading_label = /** @type {(inputs: Login_Page_Google_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando sesión con Google…`)
};

/**
* | output |
* | --- |
* | "Signing in with Google…" |
*
* @param {Login_Page_Google_Loading_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_google_loading_label = /** @type {((inputs?: Login_Page_Google_Loading_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Google_Loading_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_google_loading_label(inputs)
	if (locale === "de") return de_login_page_google_loading_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_google_loading_label(inputs)
	if (locale === "tr") return tr_login_page_google_loading_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_google_loading_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_google_loading_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_google_loading_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_google_loading_label(inputs)
	return es_419_login_page_google_loading_label(inputs)
});